import React from "react";
import RelatedMatchSelector from "./RelatedMatchSelector";
import ManageMatchLink from "./ManageMatchLink";
import PublicMatchDownloads from "./PublicMatchDownloads";
import MatchShareMenu from "./MatchShareMenu";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { matchDateLabel, matchLocation } from "./matchDiscovery";
import "./UpcomingMatchDetail.css";

export default function CancelledMatchDetail({ match, family, registration }) {
  return <article className="upcoming-match"><Helmet><title>{match.matchName} · Cancelled | Range Pocket</title></Helmet><Link className="upcoming-back" to="/matches">Find a match</Link>
    <RelatedMatchSelector match={match} family={family} />
    <header className="upcoming-hero"><span className="upcoming-eyebrow">Match cancelled</span><h1>{match.matchName}</h1><p>{matchDateLabel(match)} · {matchLocation(match)}</p><ManageMatchLink match={match} family={family} />
    <div className="public-match-actions" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8 }}>
      <PublicMatchDownloads match={match} family={family} canExportResults={false} />
      <MatchShareMenu match={match} family={family} />
    </div>
  </header><section className="upcoming-section"><h2>This match has been cancelled</h2><p>{match.lifecycle.reason}</p><p>Registration is closed. Existing registrations and scoring records are retained. Contact the match director for any arrangements related to your entry.</p>{registration?.registrationId && <Link className="upcoming-primary" to={`/matches/${family}/${encodeURIComponent(match.matchId)}/register`}>View your registration</Link>}</section></article>;
}
